import { lazy } from "react";

const ForgotPassword = lazy(() => import("./forgot-password"));
const Login = lazy(() => import("./login"));

export { ForgotPassword, Login };
